import React, { useEffect, useState } from 'react';
import { X, Check, ShieldCheck } from 'lucide-react';
interface PurchasePopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PurchasePopup({
  isOpen,
  onClose
}: PurchasePopupProps) {
  const [email, setEmail] = useState('');
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-280">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl overflow-hidden relative animate-in zoom-in-95 duration-200" data-id="element-281">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors z-10" data-id="element-282">
          <X className="w-6 h-6" data-id="element-283" />
        </button>

        <div className="bg-blue-600 p-6 text-white text-center" data-id="element-284">
          <h3 className="text-2xl font-bold mb-2" data-id="element-285">¡Último paso!</h3>
          <p className="text-blue-100 text-sm" data-id="element-286">
            Ingresá tu email para recibir el acceso inmediato
          </p>
        </div>

        <div className="p-8" data-id="element-287">
          <div className="mb-6" data-id="element-288">
            <div className="flex items-center gap-3 mb-4 p-3 bg-blue-50 rounded-lg border border-blue-100" data-id="element-289">
              <div className="bg-white p-2 rounded-md shadow-sm" data-id="element-290">
                <img src="https://cdn.magicpatterns.com/uploads/ii8qQWiRx4aNkJEZSXHaMr/pasted-image.png" alt="Product" className="w-12 h-12 object-contain" data-id="element-291" />
              </div>
              <div data-id="element-292">
                <h4 className="font-bold text-slate-900 text-sm" data-id="element-293">
                  MegaPack Artística Lista
                </h4>
                <p className="text-blue-600 font-bold" data-id="element-294">$19.990 ARS</p>
              </div>
            </div>

            <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-295">
              Tu mejor correo electrónico
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-600 focus:border-blue-600 outline-none transition-all" data-id="element-296" />
          </div>

          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-297">
            CONTINUAR AL PAGO SEGURO
          </button>

          <div className="flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-298">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-299" />
            <span data-id="element-300">Pagos procesados de forma 100% segura</span>
          </div>
        </div>
      </div>
    </div>;
}